import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../styles/Navbar.css';

interface NavLinkProps {
  to: string;
  text: string;
  closeMenu?: () => void;
}

const NavLink: React.FC<NavLinkProps> = ({ to, text, closeMenu }) => {
  const location = useLocation();
  const isActive = location.pathname === to || 
                   (location.pathname === '/' && to === '/') ||
                   (to !== '/' && location.pathname.startsWith(to));
  
  return (
    <Link 
      to={to} 
      className={isActive ? "active" : ""}
      onClick={closeMenu}
    >
      {text}
    </Link>
  );
};

const Navbar: React.FC = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  
  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };
  
  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <nav className="navbar">
      <Link to="/" className="logo">
        <span className="bracket">{'{'}</span>
        <span className="name">Ryan.Kennedy</span>
        <span className="bracket">{'}'}</span>
      </Link>
      
      <button className="mobile-menu-button" onClick={toggleMenu}>
        <div className={`menu-icon ${menuOpen ? 'open' : ''}`}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </button>
      
      <div className={`nav-links ${menuOpen ? 'active' : ''}`}>
        <NavLink to="/" text="Home" closeMenu={closeMenu} />
        <NavLink to="/about" text="About" closeMenu={closeMenu} />
        <NavLink to="/experience" text="Experience" closeMenu={closeMenu} />
        <NavLink to="/projects" text="Projects" closeMenu={closeMenu} />
        <NavLink to="/certifications" text="Certifications" closeMenu={closeMenu} />
        <NavLink to="/blog" text="Blog" closeMenu={closeMenu} />
        <NavLink to="/contact" text="Contact" closeMenu={closeMenu} />
      </div>
    </nav>
  );
};

export default Navbar; 